import { sendMQTTMessage, parseMqttResult } from './helper'
import { IMQTTRes } from './type'
import { IDiskPartition, INetDrives } from '@remote/type/hezi'
// 弹出磁盘 disk_id 磁盘名称 name
export function ejectDisk (disk_id: string): Promise<IMQTTRes> {
  return sendMQTTMessage<IMQTTRes>('xl_disk', 'eject_disk', {
    disk_id,
  }).then(parseMqttResult)
}

// format_disk 
export type TFormatDiskParams = {
  disk_id: string
  format_type: string
  correlation_id: string
  force?: boolean
}

export type IFormatDiskResult = {
  /** 为true表示格式化耗时长已放后台进行，需要通过job_id进行作业查询；为false则代表已快速格式化完成 */
  formatting: boolean
  /** 本次格式化上报的作业id */
  job_id: string
}

export function autoPartition (params: { disk_id: string }): Promise<IMQTTRes<{ list: IDiskPartition[] }>> {
  return sendMQTTMessage<IMQTTRes<{ list: IDiskPartition[] }>>('xl_disk', 'auto_partition_v2', params)
    .then(parseMqttResult)
}

export function formatDisk (params: TFormatDiskParams): Promise<IMQTTRes<IFormatDiskResult>> {
  return sendMQTTMessage<IMQTTRes<IFormatDiskResult>>('xl_disk', 'format_disk', params)
    .then(parseMqttResult)
}

// mountDisk disk_id uuid
export function mountDisk (uuid: string): Promise<IMQTTRes> {
  console.log('mountDisk', uuid)
  return sendMQTTMessage<IMQTTRes>('xl_disk', 'mount_disk', {
    disk_id: uuid,
  })
    .then(parseMqttResult)
}

export interface IPreviewNetDriveParams {
  url: string
  user: string
  password: string
}
export interface ISmbSharedFolderPickItem {
  name: string
  selected?: boolean
}

export type TInsertNetDriveParams = {
  url: string
  user?: string
  password?: string
}

export async function previewNetDriveFolderList (setting: IPreviewNetDriveParams): Promise<ISmbSharedFolderPickItem[]> {
  // @ts-ignore
  return Promise.race([
    new Promise((r, j) => setTimeout(() => {
      j('接口请求超时')
    }, 5000)),
    sendMQTTMessage<IMQTTRes<{ list: ISmbSharedFolderPickItem[] }>>('xl_disk', 'browse_net_drive', { setting })
      .then(parseMqttResult)
      .then((response: IMQTTRes<{ list: ISmbSharedFolderPickItem[] }>) => {
        return Array.isArray(response?.result?.list) ? response?.result?.list : []
      }),
  ])
}

export function insertNetDrive (params: TInsertNetDriveParams) {
  return Promise.race([
    new Promise((r, j) => setTimeout(() => {
      j('接口请求超时')
    }, 5000)),
    sendMQTTMessage<IMQTTRes<{ id: string }>>('xl_disk', 'insert_net_drive', { setting: params })
      .then(parseMqttResult),
  ])
}

export function getNetDrives () {
  return sendMQTTMessage<IMQTTRes<{ list: INetDrives[] }>>('xl_disk', 'get_net_drives')
    .then(parseMqttResult)
}

export function removeNetDrives (id: string) {
  return sendMQTTMessage<IMQTTRes>('xl_disk', 'remove_net_drive', { id })
    .then(parseMqttResult)
}